import type { WorkflowTriggerCreateDTO, WorkflowTriggerDTO } from '../workflow.types';
import { WorkflowBaseTriggerDTOModel } from '@repositories/workflowBaseTriggerRepository/models/WorkflowBaseTriggerDTOModel';
import { WorkflowTriggerConditionDTOModel } from './WorkflowTriggerConditionDTOModel';

export class WorkflowTriggerDTOModel {
  private readonly _dto: WorkflowTriggerDTO;
  private _baseTrigger: WorkflowBaseTriggerDTOModel;
  private readonly _conditions: WorkflowTriggerConditionDTOModel[];

  constructor(dto: WorkflowTriggerDTO) {
    this._dto = dto;
    this._baseTrigger = new WorkflowBaseTriggerDTOModel(dto.baseTrigger || {});
    this._conditions = dto.conditions?.length
      ? dto.conditions.map(condition => new WorkflowTriggerConditionDTOModel(condition))
      : [];
  }

  get originDTO(): WorkflowTriggerDTO {
    return this._dto;
  }

  get baseTrigger() {
    return this._baseTrigger;
  }

  set baseTrigger(value: WorkflowBaseTriggerDTOModel) {
    this._baseTrigger = value;
  }

  get conditions() {
    return this._conditions;
  }

  get cronExpression() {
    return this._dto.cronExpression;
  }

  get cronTimeZone() {
    return this._dto.cronTimeZone;
  }

  get customConditionExpression() {
    return this._dto.customConditionExpression;
  }

  get id() {
    return this._dto.id || '';
  }

  toCreateDTO(): WorkflowTriggerCreateDTO {
    return {
      baseTriggerId: this._baseTrigger.id,
      conditions: this._conditions.map(condition => ({
        fieldName: condition.fieldName,
        logicalOperator: condition.logicalOperator,
        operator: condition.operator,
        value: condition.value,
      })),
      cronExpression: this._dto.cronExpression,
      cronTimeZone: this._dto.cronTimeZone,
      customConditionExpression: this._dto.customConditionExpression,
    };
  }
}
